
import { DEV_LOCAL, DEV_AWS, PROD_AWS, PROD_LOCAL } from "../../lib/constants";
import { sprintf } from "sprintf-js";

const region = 'us-west-2';
const s3_url = sprintf('https://s3-%s.amazonaws.com', region);
const bucket = 'clever-alpha-account';
const dev_prefix = 'dev-css';
const prod_prefix = 'prod-css';

/**
 * Depending on the environment, appends the proper prefix to
 * form a proper url.
 *
 * @param config: {Config} proto
 * @param path: {String} path
 */
const css_file_to_url = (config, path) => {

  if (config.env === DEV_LOCAL || config.env === DEV_AWS) {
    return s3_url + '/' + bucket + '/' + dev_prefix + '/' + path;
  }

  if (config.env === PROD_AWS || config.env === PROD_LOCAL) {
    return s3_url + '/' + bucket + '/' + prod_prefix + '/' + path;
  }

  throw new Error("Unknown state " + config.env);
};

export { css_file_to_url };
